/** Figma's glyphs inside its 16px action box: Material's close drawn at 16px is a 10px cross. */
export const CLOSE_GLYPH = 10;
export const TOGGLE_GLYPH = 16;

export const CLOSE_LABEL = "Close alert";
export const TOGGLE_LABEL = "Show details";
export const PROGRESS_LABEL = "Progress";
